import { DeleteOutline, Save, Terminal } from "@mui/icons-material";
import { Button, Chip, IconButton, Stack, Tooltip, Typography } from "@mui/material";

type StudioTopBarProps = {
    packageName: string;
    packageRequired: boolean;
    saveDisabled: boolean;
    deleteDisabled: boolean;
    tt: (key: string, fallback: string) => string;
    onSave: () => void;
    onDelete: () => void;
};

const StudioTopBar = ({
    packageName,
    packageRequired,
    saveDisabled,
    deleteDisabled,
    tt,
    onSave,
    onDelete,
}: StudioTopBarProps) => (
    <div className="platform-studio__topbar">
        <Stack direction="row" spacing={1.25} alignItems="center" minWidth={0}>
            <Terminal fontSize="small" />
            <Typography className="platform-studio__title" noWrap>
                {tt("studio.title", "Platform Studio")}
            </Typography>
            <Chip
                size="small"
                label={packageName}
                color={packageRequired ? "warning" : "success"}
                variant={packageRequired ? "outlined" : "filled"}
            />
        </Stack>
        <Stack direction="row" spacing={0.5} alignItems="center">
            <Tooltip title={tt("studio.action.save", "Save")}>
                <span>
                    <Button
                        size="small"
                        variant="contained"
                        startIcon={<Save fontSize="small" />}
                        disabled={saveDisabled}
                        onClick={onSave}
                    >
                        {tt("studio.action.save", "Save")}
                    </Button>
                </span>
            </Tooltip>
            <Tooltip title={tt("studio.action.delete_selected", "Delete selected record")}>
                <span>
                    <IconButton
                        size="small"
                        disabled={deleteDisabled}
                        onClick={onDelete}
                    >
                        <DeleteOutline fontSize="small" />
                    </IconButton>
                </span>
            </Tooltip>
        </Stack>
    </div>
);

export default StudioTopBar;
